import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import _ from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({})
export default class PatientDetailPACU extends Vue {
  @Getter("config", patientNamespace)
  config!: any;

  @Getter("now", patientNamespace)
  now: any;

  @Prop(Object)
  data!: Patient;

  numberOfLinesToShow = 2;

  get procedureText() {
    const text = _.get(
      this,
      "data.census.atoms.procedureName.legend"
    ) as string;
    if (text) {
      return text
        .toLocaleLowerCase()
        .replace(/(\w+)/g, (c: string) => c[0].toUpperCase() + c.slice(1))
        .split(/\|+|\r\n+|\n+/);
    } else {
      return [];
    }
  }

  get operatingRoom(): string {
    return _.get(this, "data.body.previousOR", "") as string;
  }
}
